import type { Root } from "mdast";
import { findAndReplace } from "mdast-util-find-and-replace";
import type { Plugin } from "unified";

import { PHONE_RE, phoneToTelHref } from "./phoneLinkRules";

/**
 * remark plugin: autolink phone numbers as `tel:` links (ENG-3042).
 *
 * remark-gfm autolinks bare URLs and emails but not phones. The first cut did
 * a regex replace over the RAW markdown before parsing, which had no idea
 * where existing links were and so injected a link inside a link — CommonMark
 * forbids nested links, so `[Call us (555) 123-4567](https://…)` lost its
 * outer link and `[Call](tel:555-123-4567)` silently became an undialable
 * `tel:[555-123-4567](tel:+1…)` href (QA rejection, 2026-08-24).
 *
 * Running on the mdast tree AFTER parsing, with `ignore: ["link",
 * "linkReference"]`, is exactly how remark-gfm's own autolink-literal works:
 * text already inside a link is never touched, so an explicit link — however
 * the model wrote it — survives intact.
 */
export const remarkPhoneLinks: Plugin<[], Root> = () => (tree) => {
  findAndReplace(
    tree,
    [
      PHONE_RE,
      (match: string) => ({
        type: "link",
        url: phoneToTelHref(match),
        title: null,
        children: [{ type: "text", value: match }]
      })
    ],
    { ignore: ["link", "linkReference"] }
  );
};
